import styles from "@/components/common/styles/button-with-icon.module.scss";
import Image from "next/image";
import { useMobile } from "@/hooks/use-responsive";

export interface ButtonProps {
  isEnabled: boolean;
  handleClick: () => void;
}

interface ButtonWithIconProps extends ButtonProps {
  text?: string;
  iconPath: string;
  disabledIconPath?: string;
  tooltip: string;
  size?: number;
}

const ButtonWithIcon = ({
  isEnabled,
  handleClick,
  text,
  iconPath,
  disabledIconPath,
  tooltip,
  size,
}: ButtonWithIconProps) => {
  const { isMobile } = useMobile();

  return (
    <button
      className={styles.button}
      onClick={handleClick}
      disabled={!isEnabled}
    >
      <Image
        src={!isEnabled && disabledIconPath ? disabledIconPath : iconPath}
        alt={tooltip}
        height={size}
        width={size}
      />
      {!isMobile && <>{text}</>}
    </button>
  );
};

export default ButtonWithIcon;
